import { AuthService } from './../../../auth/services/auth/auth.service';
import { Component, OnInit, HostBinding } from '@angular/core';
import { AccountConfigService } from '../../services/account-config/account-config.service';

@Component({
  selector: 'ags-account-home-button',
  templateUrl: './account-home-button.component.html',
  styleUrls: ['./account-home-button.component.scss']
})
export class AccountHomeButtonComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  name: string;
  userName = this.authService.userConnected.company.name;

  public linkToAccount: string;
  constructor(private accountConfigService: AccountConfigService, private authService: AuthService) {
    this.themeFlag = `${this.themeFlag || ''} ${accountConfigService.themingClassName} exported`;
  }

  ngOnInit() {
    this.linkToAccount = `/${this.accountConfigService.routingBaseUri}`;
  }
}
